import { BcAntenatalRadioTextboxField } from "@/Patient/Models/ObstetricalFile/BritishColumbia/BcAntenatalRadioTextboxField";

class MedicalHistoryCardiovascular {
    public HasCardiovascular?: boolean = null;
    public HasHypertension?: boolean = null;
    public HasPreviousHypertension?: boolean = null;
    public Other: BcAntenatalRadioTextboxField;

    public constructor(fields?: Partial<MedicalHistoryCardiovascular>) {
        Object.assign(this, fields);
        this.Other = new BcAntenatalRadioTextboxField(fields?.Other);
    }

    public hasSelectedAnyMedicalHistoryCardiovascular(): boolean {
        return this.HasHypertension
            || this.HasPreviousHypertension
            || this.Other.hasSelected();
    }
}

export { MedicalHistoryCardiovascular };
